import React from 'react';
import Client from '../components/client'
import Service from '../components/service'
import Works from '../components/works'
import Testimonial from '../components/testimonial'
import Wrapper from '../components/wrapper'
import SectionTitle from '../components/sectionTitle'

const Home = ({location}) => {

  return (
    <Wrapper
      // customTitle={""} 
      // customDescription={""} 
      // customKeyword={""} 
      // customOgImage={""}
      slug={location.pathname}
      >
      <section className="bg-black bg-billboard">
        <div className="container mx-auto px-4 flex w-full h-full items-center">
          <SectionTitle 
            wrapperClassName=""
            alignCenter={true}
            title="Trailblazing digital creators."
            minititle=""
            type="h1"
            invert={true}
            childrenClassName="lg:w-4/5 text-shadow-base"
            buttonText=""
            buttonType=""
            buttonLink=""
            >
              <p>
                Blazing through the Wild Wild Web by creating exceptionally beautiful and functional digital products.
              </p>
          </SectionTitle>
        </div>
      </section>

      <section className="bg-home-about">
        <div className="container mx-auto">
            <SectionTitle 
              wrapperClassName="py-16 md:w-3/5 lg:w-2/3"
              alignCenter={true}
              title={["Designers +", <span className="hidden sm:inline-block">&nbsp;</span>, <br className="block sm:hidden"/> ,"developers."]}
              minititle="Who we are"
              type="h2"
              invert={true}
              childrenClassName="lg:w-4/5"
              buttonText="Find out more about us"
              buttonType="btn-light"
              buttonLink="/about/"
              >
                <p>
                  We are an experienced web and app design and development company. We believe in profound fusion of design + development; humanity + technology to make great products.
                </p>
            </SectionTitle>
        </div>
      </section>

      <Service/>
      <Works filterWorks={true}/>
      <Testimonial/>
      <Client/>

    </Wrapper>
  )
}


export default Home;